import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { s3_img_url } from '../../../Helper/request';

const CustomBanner=()=>{
    const loc=useLocation();
     const [screenWidth, setScreenWidth] = useState(window.screen.width);
      const resizeScreen = () => {
        setScreenWidth(window.innerWidth);
      };
      useEffect(() => {
        resizeScreen();
        window.addEventListener("resize", resizeScreen);
        return () => {
          window.removeEventListener("resize", resizeScreen);
        };
      }, []);
      
    return(
        <>
         {
            loc?.pathname==="/productlist/custom-jewelry" &&  <section className='wdd_home_custom_design' style={{paddingTop: `${screenWidth < 767 ? "53px" : "0px"}`}}>
      
            <img src={screenWidth > 767 ? (s3_img_url + 'custom-design/custom_top_desk.jpg') : (s3_img_url + 'custom-design/custom_top_mob.jpg')}   className="w-100" alt="" /> 
          
            </section>
          }
        </>
       
    )
    }
    export default CustomBanner;